/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Primary_ColorInputs */

const fr_label_primary_color = /** @type {(inputs: Label_Primary_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur primaire`)
};

const en_label_primary_color = /** @type {(inputs: Label_Primary_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary color`)
};

/**
* | output |
* | --- |
* | "Primary color" |
*
* @param {Label_Primary_ColorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_primary_color = /** @type {((inputs?: Label_Primary_ColorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Primary_ColorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_primary_color(inputs)
	return en_label_primary_color(inputs)
});